// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const productionConfig = {
  apiKey: "AIzaSyDnodgbXUWjLCDueSbSOkljetSEdH4kfZc",
  authDomain: "study-gram-4184d.firebaseapp.com",
  projectId: "study-gram-4184d",
  storageBucket: "study-gram-4184d.firebasestorage.app",
  messagingSenderId: "954541058039",
  appId: "1:954541058039:web:886a1385d4c609b12730f2",
  measurementId: "G-12S1VRW0V2"
}

// const developmentConfig = {
//   apiKey: "AIzaSyAjdvljAEeWkpMd2kF6ng0wvQTK-nmJF54",
//   authDomain: "studygram-vyzion.firebaseapp.com",
//   projectId: "studygram-vyzion",
//   storageBucket: "studygram-vyzion.firebasestorage.app",
//   messagingSenderId: "855190066393",
//   appId: "1:855190066393:web:ddb63ec9c3b82cf8935ac8",
//   measurementId: "G-9DF8FM7RGH"

// };



// Initialize Firebase
const firebaseApp = initializeApp(productionConfig);
// const analytics = getAnalytics(firebaseApp);

export const auth = getAuth(firebaseApp);
export const dbFirestore = getFirestore(firebaseApp);
export default firebaseApp;
